import { Component } from "react";
import View from "./view";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import "./index.css";
import { getUser } from "../../backend/storage";

class Page extends Component {
  constructor(props) {
    super(props);

    let fullscreen = false;
    if (["/login"].includes(this.props.location.pathname)) {
      fullscreen = true;
    }

    this.state = {
      header: this.urlToTitle(props.location.pathname),
      fullscreen,
      online: navigator.onLine
    };

    this._navigate = this._navigate.bind(this);
    this._back = this._back.bind(this);
    this._addConnectivityListeners = this._addConnectivityListeners.bind(this);
  }

  _addConnectivityListeners() {
    window.addEventListener("offline", () => this.setState({ online: false }));
    window.addEventListener("online", () => this.setState({ online: true }));
  }

  async componentDidMount() {
    this._addConnectivityListeners();

    const user = await getUser();
    if (user) this.setState({ type: user.type });
  }

  async componentDidUpdate(prevProps, prevState) {
    // If we move from fullscreen to not fullscreen, we might have just logged in/out.
    // We should update our user type
    if (prevState.fullscreen && this.state.fullscreen) {
      const { type } = await getUser();
      this.setState({ type });
    }
    let fullscreen = false;
    if (["/login"].includes(this.props.location.pathname)) {
      fullscreen = true;
    }
    if (this.state.header !== this.urlToTitle(this.props.location.pathname)) {
      this.setState({
        header: this.urlToTitle(this.props.location.pathname),
        fullscreen
      });
    }
  }

  urlToTitle(url = "") {
    return url
      .split("/")[1]
      .replace("-", " ")
      .toUpperCase();
  }

  render() {
    return View.call(this);
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }

  _back() {
    const { history } = this.props;
    history.goBack();
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    routes: state.routes
  };
};

export default withRouter(connect(mapStateToProps)(Page));



// WEBPACK FOOTER //
// ./src/components/page/index.js